module.exports = __webpack_public_path__ + "static/media/liveImage.ca4a9f1f.jpg";